import { PureComponent } from 'react'

type IProps = {
    children: string
}

export class Title extends PureComponent<IProps> {
    render() {
        return <div className="text-center text-4xl space-x-4 mb-10 select-none flex justify-center font-bold">{this.props.children}</div>
    }
}
